import KeywordMessageBubble from './KeywordMessageBubble';
import { getConversationName } from './helper';
import BEM from 'common/bem';
import { mobxInjectSelect } from 'common/utils';
import { User, Group } from 'types';
import { KeywordSearchGeneralResult } from 'js-sdk/src/apis/SearchAPI';
import { actions, useAppDispatch } from 'redux-stores';

type KeywordSearchMessageListMobxProps = {
  getEntityData: (entityType: string, id: string) => User | Group;
  currentUserId: string;
  currentRoleBotUserIds: string[];
};

interface KeywordSearchMessageListProps {
  value: KeywordSearchGeneralResult;
  extraPadding?: boolean;
}

const { setSelectedConversationId } = actions;

const classes = BEM.with('KeywordSearchSideBar');

const KeywordSearchMessageList = ({
  value,
  getEntityData,
  currentUserId,
  currentRoleBotUserIds,
  extraPadding = false,
}: KeywordSearchMessageListProps & KeywordSearchMessageListMobxProps) => {
  const entity = value.entity;
  const dispatch = useAppDispatch();

  const handleSeeAllClick = (conversationId: string) => {
    dispatch(setSelectedConversationId(conversationId));
  };

  return (
    <div
      className={classes('conversation-result', {
        'extra-padding': extraPadding,
      })}
      key={entity?.conversation_id}
    >
      <div className={classes('conversation-header')}>
        <div className={classes('conversation-name')}>
          {getConversationName(entity?.conversation_metadata, getEntityData)}
        </div>
        {entity?.total_hits_value > 2 && (
          <button
            className={classes('seeAll-label')}
            onClick={() => handleSeeAllClick(entity?.conversation_id)}
            type="button"
            name="See All"
          >
            See All
          </button>
        )}
      </div>
      <div className={classes('message-results')}>
        {entity?.values.map(
          ({
            body,
            created_time_server,
            highlight,
            sender_token,
            sender_user_token,
            sender_role_token,
            is_group,
            message_id,
            sort_number,
          }) => {
            return (
              <KeywordMessageBubble
                id={`${message_id}-first-level-result`}
                key={message_id}
                body={body}
                conversationMetadata={entity.conversation_metadata}
                createdTime={created_time_server}
                isGroup={is_group}
                currentUserId={currentUserId}
                myRoleIds={currentRoleBotUserIds}
                senderToken={sender_token}
                senderUserToken={sender_user_token}
                senderRoleToken={sender_role_token}
                highlight={highlight}
                messageId={message_id}
                sort_number={sort_number}
              />
            );
          }
        )}
      </div>
    </div>
  );
};

export default mobxInjectSelect<KeywordSearchMessageListProps, KeywordSearchMessageListMobxProps>({
  entityStore: ['getEntityData'],
  roleStore: ['currentRoleBotUserIds'],
  sessionStore: ['currentUserId'],
})(KeywordSearchMessageList);
